module.exports = __webpack_public_path__ + "img/18_90.b3b3b09b.png";